<template>
  <div class="natWarningSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="4">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('alarms.common.pleaseSelectCompany')"
            :transfer="true"
            @on-change="searchCompany"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="3">
        <Select
          v-model="accountType"
          filterable
          :placeholder="$t('alarms.common.filterByAccountType')"
          @on-change="searchAccountType()"
          :transfer="true"
        >
          <Option value="" selected>{{ $t("alarms.common.all") }}</Option>
          <Option
            :value="item.id"
            v-for="item in accountTypeList"
            :key="item.name"
            >{{ item.name }}</Option
          >
        </Select>
      </Col>
      <Col span="4">
        <!-- v-on:input实时查询 -->
        <Input
          search
          v-model="accountName"
          :placeholder="$t('alarms.common.filterByAccountName')"
          @on-search="searchAccountName()"
        />
      </Col>
      <Col span="4">
        <!-- v-on:input实时查询 -->
        <Input
          search
          v-model="natGatewayId"
          :placeholder="$t('alarms.common.filterByNatGatewayId')"
          @on-search="searchNatGatewayId()"
        />
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../utils/cookieUtil";
export default {
  name: "NatWarningSearch",
  data() {
    return {
      modal_loading: false,
      tag: "",
      region: [],
      instanceId: "",
      regionList: [],
      regionName: "",
      instanceName: "",
      accountName: "",
      accountType: "",
      natGatewayId: "",
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      accountTypeList: [
        {
          id: 0,
          name: "AWS",
        },
        {
          id: 1,
          name: "Aliyun",
        },
        {
          id: 2,
          name: "Azure",
        },
        {
          id: 3,
          name: "VMware",
        },
        {
          id: 4,
          name: "GCP",
        },
      ],
    };
  },
  mounted: function () {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
  },
  methods: {
    // 获取公司下拉框
    getCompanyDropDownBox: function () {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then((res) => {
          this.companyList = res.data;
        });
    },
    // 按公司搜索
    searchCompany: function () {
      // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
      eventBus.$emit("companyId", this.companyId);
      this.$parent.methods.showAll();
    },
    // 按账户类型筛选
    searchAccountType: function () {
      eventBus.$emit("accountType", this.accountType);
      this.$parent.showAll();
    },
    // 按账户名称搜索
    searchAccountName: function () {
      // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
      eventBus.$emit("accountName", this.accountName);
      this.$parent.methods.showAll();
    },
    // 按nat网关搜索
    searchNatGatewayId: function () {
      // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
      eventBus.$emit("natGatewayId", this.natGatewayId);
      this.$parent.methods.showAll();
    },
  },
};
</script>
<style scoped>
.natWarningSearch {
  height: 51px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/network/nat/NatWarningSearch.vue